import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col border-t border-concrete-300" }
const _hoisted_2 = ["aria-expanded", "onClick"]
const _hoisted_3 = { class: "pr-8 font-primary text-lg font-bold text-black transition-colors duration-200 group-hover:text-orange-500" }
const _hoisted_4 = { class: "overflow-hidden" }
const _hoisted_5 = { class: "pb-6 text-concrete-700" }

import { ref } from "vue";
import Prose from "~/vue/atoms/texts/TextProse.vue";

interface FaqItem {
	id: string | number;
	question: string;
	answer: string;
}

interface Props {
	items: FaqItem[];
	animate?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'GridFaq',
  props: {
    items: {},
    animate: { type: Boolean, default: false }
  },
  setup(__props: any) {



const activeIndex = ref<number | null>(null);

const toggle = (index: number) => {
	if (activeIndex.value === index) {
		activeIndex.value = null;
	} else {
		activeIndex.value = index;
	}
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["w-full", __props.animate ? 'animate-fade-in-up' : ''])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.id,
          class: "border-b border-concrete-300"
        }, [
          _createElementVNode("button", {
            class: "group flex w-full cursor-pointer items-center justify-between py-6 text-left focus:outline-none focus:ring-2 focus:ring-inset focus:ring-celestial-500",
            "aria-expanded": activeIndex.value === index,
            onClick: ($event: any) => (toggle(index))
          }, [
            _createElementVNode("span", _hoisted_3, _toDisplayString(item.question), 1),
            _createElementVNode("span", {
              class: _normalizeClass(["ml-4 shrink-0 transform text-viridian-500 transition-transform duration-300", activeIndex.value === index ? 'rotate-180' : 'rotate-0'])
            }, [...(_cache[0] || (_cache[0] = [
              _createElementVNode("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "16",
                height: "16",
                fill: "currentColor",
                viewBox: "0 0 16 16"
              }, [
                _createElementVNode("path", {
                  "fill-rule": "evenodd",
                  d: "M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
                })
              ], -1)
            ]))], 2)
          ], 8, _hoisted_2),
          _createElementVNode("div", {
            class: _normalizeClass(["grid transition-all duration-300 ease-in-out", activeIndex.value === index ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'])
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(Prose, {
                  html: item.answer
                }, null, 8, ["html"])
              ])
            ])
          ], 2)
        ]))
      }), 128))
    ])
  ], 2))
}
}

})